/**
* The route defaults for a route configuration
*/
export class RouteDefaults {
    public routeName: string;
}
